import { DataScope } from 'src/app/core/models/data-scope';
import { Page } from 'src/app/core/models/page';
import { PageInfo } from './../../../../../core/models/page-info';
import { OrderQueryScopeEnum } from 'src/app/core/enums/order-query-scope.enum';
export class ReceivingInstructionRequest extends Page {
  receivingRequestHeader?: string
  receivingRequestDetail?: string
  facility?: string
  hawbNo?: string[]
  invoiceNo?: string[]
  receivedDtStart?: Date
  receivedDtEnd?: Date
  createDtStart?: Date
  createDtEnd?: Date
  vendorNumber?: string[]
  importDeclarationNo?: string[]
  adNo?: string[]
  sku?: string
  docStatus?: string
  userId?: string
  dataScopes: DataScope[]
  orderType?: string
  pcsrEmail?: string
  isNotify?: number
  orderQueryScope: OrderQueryScopeEnum;

  constructor () {
    super();
    this.adNo = undefined;
    this.docStatus = undefined;
    this.facility = undefined;
    this.hawbNo = undefined;
    this.importDeclarationNo = undefined;
    this.invoiceNo = undefined;
    this.receivedDtEnd = undefined;
    this.receivedDtStart = undefined;
    this.receivingRequestHeader = undefined;
    this.receivingRequestDetail = undefined;
    this.sku = undefined;
    this.vendorNumber = undefined;
    this.sortInfo = undefined;
    this.pageIndex = undefined;
    this.pageSize = undefined;
    this.userId = undefined;
    this.createDtStart = undefined;
    this.createDtEnd = undefined;
    this.dataScopes = [];
    this.orderType = undefined;
    this.pcsrEmail = undefined;
    this.isNotify = undefined;
    this.orderQueryScope = OrderQueryScopeEnum.all;
  }
}

